import { useState, useEffect } from 'react'
import { localization } from '@ocean/configs'

const { i18n } = localization

type ExpandAllInParams = {
  itemsCount: number
  expandedByDefault?: boolean
  alwaysExpandedItemIndex?: number
}

type ExpandAllOutParams = {
  expandCollapseText: string
  sectionsExpansion: boolean[]
  toggleExpandAll: () => void
  changeItemExpansion: (itemIndex: number, isExpanded: boolean) => void
}

const useExpandAll = (props: ExpandAllInParams): ExpandAllOutParams => {
  const { itemsCount, expandedByDefault = false, alwaysExpandedItemIndex } = props
  const [sectionsExpansion, setSectionsExpansion] = useState<boolean[]>([])
  const [allExpanded, setAllExpanded] = useState<boolean>()
  const expandCollapseText = i18n.t(`expand.${allExpanded ? 'showLess' : 'showAll'}`)

  // Initiation
  useEffect(() => {
    handleExpansion(expandedByDefault)
  }, [alwaysExpandedItemIndex, itemsCount, expandedByDefault]) // eslint-disable-line react-hooks/exhaustive-deps

  function handleToggleAll() {
    handleExpansion(!allExpanded)
  }

  function handleExpansion(allExpanded: boolean) {
    const expansionArray = new Array(itemsCount).fill(allExpanded)
    alwaysExpandedItemIndex !== undefined && (expansionArray[alwaysExpandedItemIndex] = true)
    setSectionsExpansion(expansionArray)
  }

  function handleItemExpansion(itemIndex: number, isExpanded: boolean) {
    const newSectionsExpansion = [...sectionsExpansion]
    newSectionsExpansion[itemIndex] = isExpanded
    setSectionsExpansion(newSectionsExpansion)
    checkIsAllExpanded(newSectionsExpansion)
  }

  function checkIsAllExpanded(newSectionsExpansion: boolean[]) {
    const expanded = newSectionsExpansion.filter(sectionExpansion => sectionExpansion)
    if (expanded.length === itemsCount && !allExpanded) return setAllExpanded(true)
    if (expanded.length < itemsCount && allExpanded) return setAllExpanded(false)
  }

  return {
    expandCollapseText,
    toggleExpandAll: handleToggleAll,
    changeItemExpansion: handleItemExpansion,
    sectionsExpansion,
  }
}

export default useExpandAll
